/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CreateLevelDto } from '../model/models';
import { InlineResponse401 } from '../model/models';
import { LevelItemDto } from '../model/models';
import { LevelListResponseDto } from '../model/models';
import { UpdateLevelDto } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    LevelsServiceInterface,
    CreateLevelRequestParams,
    DeleteLevelRequestParams,
    GetLevelRequestParams,
    ListLevelsRequestParams,
    ReplaceLevelRequestParams
} from './levels.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class LevelsService implements LevelsServiceInterface {

    protected basePath = 'https://staging.convercus.io';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Create level override
     * Persists a wallet level override for a key (appearance fields). Image URLs must be HTTPS. A key that already has an override is rejected with 409.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createLevel(requestParameters: CreateLevelRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LevelItemDto>;
    public createLevel(requestParameters: CreateLevelRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LevelItemDto>>;
    public createLevel(requestParameters: CreateLevelRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LevelItemDto>>;
    public createLevel(requestParameters: CreateLevelRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const createLevelDto = requestParameters.createLevelDto;
        if (createLevelDto === null || createLevelDto === undefined) {
            throw new Error('Required parameter createLevelDto was null or undefined when calling createLevel.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling createLevel.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<LevelItemDto>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/levels`,
            createLevelDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete level override
     * Removes the persisted override so the level falls back to catalog / program design defaults. Catalog-only keys cannot be deleted this way (404).
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteLevel(requestParameters: DeleteLevelRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public deleteLevel(requestParameters: DeleteLevelRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public deleteLevel(requestParameters: DeleteLevelRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<any>>;
    public deleteLevel(requestParameters: DeleteLevelRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling deleteLevel.');
        }
        const levelKey = requestParameters.levelKey;
        if (levelKey === null || levelKey === undefined) {
            throw new Error('Required parameter levelKey was null or undefined when calling deleteLevel.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/levels/${encodeURIComponent(String(levelKey))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get wallet level
     * Returns the catalog row, override, or both for one level key. 404 if the key is neither in the catalog nor persisted.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLevel(requestParameters: GetLevelRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LevelItemDto>;
    public getLevel(requestParameters: GetLevelRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LevelItemDto>>;
    public getLevel(requestParameters: GetLevelRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LevelItemDto>>;
    public getLevel(requestParameters: GetLevelRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling getLevel.');
        }
        const levelKey = requestParameters.levelKey;
        if (levelKey === null || levelKey === undefined) {
            throw new Error('Required parameter levelKey was null or undefined when calling getLevel.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<LevelItemDto>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/levels/${encodeURIComponent(String(levelKey))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List wallet levels
     * Returns catalog keys merged with persisted wallet level overrides for the program. Toom uses a fixed VTK catalog; other programs use Convercus status-level sets when &#x60;convercusProgramId&#x60; is set.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listLevels(requestParameters: ListLevelsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LevelListResponseDto>;
    public listLevels(requestParameters: ListLevelsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LevelListResponseDto>>;
    public listLevels(requestParameters: ListLevelsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LevelListResponseDto>>;
    public listLevels(requestParameters: ListLevelsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling listLevels.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<LevelListResponseDto>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/levels`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace level override
     * Replaces persisted override fields. Omitted appearance fields are dropped and fall back to program design. &#x60;newKey&#x60; is rejected (keys cannot be renamed). Image URLs must be HTTPS.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public replaceLevel(requestParameters: ReplaceLevelRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LevelItemDto>;
    public replaceLevel(requestParameters: ReplaceLevelRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LevelItemDto>>;
    public replaceLevel(requestParameters: ReplaceLevelRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LevelItemDto>>;
    public replaceLevel(requestParameters: ReplaceLevelRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const updateLevelDto = requestParameters.updateLevelDto;
        if (updateLevelDto === null || updateLevelDto === undefined) {
            throw new Error('Required parameter updateLevelDto was null or undefined when calling replaceLevel.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling replaceLevel.');
        }
        const levelKey = requestParameters.levelKey;
        if (levelKey === null || levelKey === undefined) {
            throw new Error('Required parameter levelKey was null or undefined when calling replaceLevel.');
        }
        const xAdminKey = requestParameters.xAdminKey;

        let headers = this.defaultHeaders;
        if (xAdminKey !== undefined && xAdminKey !== null) {
            headers = headers.set('x-admin-key', String(xAdminKey));
        }

        let credential: string | undefined;
        // authentication (Admin) required
        credential = this.configuration.lookupCredential('Admin');
        if (credential) {
            headers = headers.set('x-admin-key', credential);
        }

        // authentication (Admin JWT) required
        credential = this.configuration.lookupCredential('Admin JWT');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<LevelItemDto>(`${this.configuration.basePath}/wallet-pass-service/v1/admin/programs/${encodeURIComponent(String(programId))}/levels/${encodeURIComponent(String(levelKey))}`,
            updateLevelDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
